<template>
  <div class="answer-list-container">
    <question-group-list v-for="group in orderedGroups" :group="group" :key="group.id"></question-group-list>
  </div>
</template>

<script>
import _ from 'lodash';
import QuestionGroupList from './QuestionGroupList';

export default {
  components: {
    QuestionGroupList
  },
  name: 'answer-list',
  props: ['groups'],
  computed: {
    orderedGroups: function() {
      return _.orderBy(this.groups, 'number');
    }
  }
};
</script>

<style scoped lang="scss">
.answer-list-container {
  height: calc(97vh - 267px);
  max-height: calc(97vh - 267px);
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
</style>
